



import SettingListComponent from "@/components/admin/setting/settingListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "SettingListPage",
  components: {
    SettingListComponent,
  },
})
export default class SettingListPage extends Vue {}
